import { sortByNames } from '../utils/businessLogic/house/sortByNames';
import { sortByOffers } from '../utils/businessLogic/house/sortByOffers';

export enum EHouseSorting {
  Offers,
  Names,
}

export const HOUSE_SORTINGS_MAP = {
  [EHouseSorting.Offers]: sortByOffers,
  [EHouseSorting.Names]: sortByNames,
};

export const HOUSE_SORTINGS = [
  { id: EHouseSorting.Offers, text: 'По количеству квартир' },
  { id: EHouseSorting.Names, text: 'По корпусам' },
];
